import React, { useState, useContext } from "react";
import { observer } from "mobx-react";
import { AutoCompleteContext } from "Components/common/AutoCompleteDropdown";
import scheduleDataStore from "Stores/ScheduleData";
import { PRESET_SCHEDULES, createScheduleFromPreset } from "./schedulePresets";

// Once the account has this many schedules, the team knows how to make them;
// the preset section retires from the dropdown (still on Settings > Schedules).
const PRESETS_RETIRE_AT = 5;

// Dropdown row with an inline edit affordance; used via AutoCompleteDropdown's
// updateListBody/Body support (shared component untouched).
const ScheduleOptionRow = (props = {}) => {
  const { name = "", default: isDefault = false, onEdit = () => {} } = props;
  return (
    <div className="scheduleOptionRow">
      <span className="updatedName">{name}</span>
      {isDefault && <span className="defaultValue">Default</span>}
      <button
        type="button"
        className="scheduleEditIcon"
        title="Edit schedule"
        onClick={event => {
          event.stopPropagation();
          onEdit(props);
        }}
      >
        <i className="material-icons">edit</i>
      </button>
    </div>
  );
};

const SchedulePresetList = observer((props = {}) => {
  const { onSelect = () => {}, onOpenCreateModal = () => {} } = props || {};
  const {
    setDropdownValue = () => {},
    setShowDropdown = () => {},
    setShowDropdownMenu = () => {}
  } = useContext(AutoCompleteContext);

  const [creatingKey, setCreatingKey] = useState("");

  const schedules = scheduleDataStore?.scheduleData?.data || [];
  const existingNames = new Set(schedules.map(item => item?.name));
  const presetsToShow =
    schedules.length >= PRESETS_RETIRE_AT
      ? []
      : PRESET_SCHEDULES.filter(preset => !existingNames.has(preset?.name));

  const closeDropdown = () => {
    setShowDropdownMenu(false);
    setShowDropdown(false);
  };

  const handlePresetClick = async (preset = {}) => {
    if (creatingKey) {
      return;
    }
    setCreatingKey(preset?.key);
    const schedule = await createScheduleFromPreset(preset);
    setCreatingKey("");
    if (schedule?.id) {
      setDropdownValue(schedule.name);
      closeDropdown();
      onSelect(schedule);
    }
  };

  const handleCreateNewClick = () => {
    closeDropdown();
    onOpenCreateModal();
  };

  return (
    <div className="schedulePresetSection">
      {presetsToShow.length > 0 && (
        <>
          <div className="presetSectionLabel">Quick presets</div>
          <ul className="presetList">
            {presetsToShow.map((preset = {}) => (
              <li
                key={preset?.key}
                className={`presetOption ${
                  creatingKey === preset?.key ? "creating" : ""
                }`}
                onClick={() => handlePresetClick(preset)}
              >
                <span className="presetName">{preset?.name}</span>
                <span className="presetHint">{preset?.hint}</span>
                {creatingKey === preset?.key && (
                  <span className="presetSpinner" />
                )}
              </li>
            ))}
          </ul>
        </>
      )}
      <div className="createNewScheduleBtn" onClick={handleCreateNewClick}>
        <i className="material-icons">add</i>
        <span className="btnText">Create new schedule</span>
      </div>
    </div>
  );
});

export default SchedulePresetList;
export { SchedulePresetList, ScheduleOptionRow };
